import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { CaretDown, Trash } from 'phosphor-react'
import CustomDatePicker from 'components/common/custom-datepicker/CustomDatepicker'

function AgendaAccordionCard({
  title,
  isOpen,
  onToggle,
  onDelete,
  agendaItem,
  errors,
  submitCount,
  onChange,
}) {
  const [titleTouched, setTitleTouched] = useState(false)
  const initialSubmitCountRef = useRef(submitCount)
  const descriptionLength = (agendaItem?.description || '').length
  const shouldShowSubmitErrors = submitCount > initialSubmitCountRef.current

  return (
    <div className='event-agenda-card'>
      <div className='event-agenda-card__header'>
        <button
          type='button'
          className='event-agenda-card__toggle'
          onClick={onToggle}
          aria-expanded={isOpen}
        >
          <CaretDown
            size={18}
            className={`event-agenda-card__caret ${
              isOpen ? 'event-agenda-card__caret--open' : ''
            }`}
          />
          <span>{title}</span>
        </button>
        <button
          type='button'
          className='event-agenda-card__delete'
          onClick={onDelete}
          aria-label='Delete agenda'
        >
          <Trash size={16} />
        </button>
      </div>

      {isOpen ? (
        <div className='event-agenda-card__body'>
          <div className='event-agenda-field'>
            <label htmlFor={`${title}-agenda-title`}>
              Title <span className='event-required-star'>*</span>
            </label>
            <input
              id={`${title}-agenda-title`}
              value={agendaItem?.title || ''}
              onChange={(e) => {
                setTitleTouched(true)
                onChange('title', e.target.value)
              }}
              onBlur={() => setTitleTouched(true)}
              placeholder='Type Here'
            />
            {errors?.title && (titleTouched || shouldShowSubmitErrors) ? (
              <p className='error-text mb-0'>{errors.title}</p>
            ) : null}
          </div>

          <div className='event-agenda-grid'>
            <div className='event-agenda-field event-agenda-field--date'>
              <CustomDatePicker
                name={`${title}-startDate`}
                label='Date From *'
                selected={agendaItem?.startDate ? new Date(agendaItem.startDate) : null}
                onDateChange={(date) => onChange('startDate', date)}
                dateFormat='dd / MM / yyyy h:mm aa'
                placeholderText='DD / MM / YYYY HH:MM'
                showTimeSelect
              />
              {shouldShowSubmitErrors && errors?.startDate ? (
                <p className='error-text mb-0'>{errors.startDate}</p>
              ) : null}
            </div>
            <div className='event-agenda-field event-agenda-field--date'>
              <CustomDatePicker
                name={`${title}-endDate`}
                label='Date to *'
                selected={agendaItem?.endDate ? new Date(agendaItem.endDate) : null}
                onDateChange={(date) => onChange('endDate', date)}
                dateFormat='dd / MM / yyyy h:mm aa'
                placeholderText='DD / MM / YYYY HH:MM'
                showTimeSelect
              />
              {shouldShowSubmitErrors && errors?.endDate ? (
                <p className='error-text mb-0'>{errors.endDate}</p>
              ) : null}
            </div>
          </div>

          <div className='event-agenda-field event-agenda-field--textarea'>
            <label htmlFor={`${title}-agenda-description`}>Description</label>
            <textarea
              id={`${title}-agenda-description`}
              value={agendaItem?.description || ''}
              onChange={(e) => onChange('description', e.target.value)}
              placeholder='Write Here'
              maxLength={200}
            />
            <p className='event-agenda-field__counter'>{`${descriptionLength}/200`}</p>
          </div>
        </div>
      ) : null}
    </div>
  )
}

AgendaAccordionCard.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  agendaItem: PropTypes.shape({
    title: PropTypes.string,
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    description: PropTypes.string,
  }),
  errors: PropTypes.shape({
    title: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  submitCount: PropTypes.number,
}

AgendaAccordionCard.defaultProps = {
  agendaItem: {},
  errors: undefined,
  submitCount: 0,
}

export default AgendaAccordionCard
